// Function to check if all recipient information has been filled in chord cart's giftCards
export const checkForFilledGiftCards = items => {
  const gcs = items.map(x => (x.giftCards.length ? x.giftCards[0] : null))
  let filledArr = gcs.filter(i => i !== null).map(x => x.filled)
  return !filledArr.includes(false)
}
